import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["requestsList"]

  addRequest() {
    const existing = this.requestsListTarget.querySelector(".bg-white")
    if (!existing) return

    const clone = existing.cloneNode(true)

    clone.querySelectorAll("textarea").forEach(ta => { ta.value = "" })
    clone.querySelectorAll("select").forEach(sel => { sel.selectedIndex = 0 })
    clone.querySelectorAll("input[type='hidden']").forEach(inp => { inp.value = "" })

    this.requestsListTarget.appendChild(clone)
  }
}
